import { authClient, API } from '../index'

export const getMultimedia = () => {
  return authClient().get(`${API}/multimedia`)
}

export const getMultimediaById = (id) => {
  return authClient().get(`${API}/multimedia/${id}`)
}

export const postMultimedia = (data) => {
  return authClient().post(`${API}/multimedia`, data)
}

export const updateMultimedia = (id, data) => {
  return authClient().put(`${API}/multimedia/${id}`, data)
}

export const deleteMultimedia = (id) => {
  return authClient().delete(`${API}/multimedia/${id}`)
}


